import { render, staticRenderFns } from "./ClinicSignUp.vue?vue&type=template&id=67fbd6f5"
import script from "./ClinicSignUp.vue?vue&type=script&lang=js"
export * from "./ClinicSignUp.vue?vue&type=script&lang=js"
import style0 from "./ClinicSignUp.vue?vue&type=style&index=0&id=67fbd6f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports